import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import Button from 'components/inputs/Button';
import * as Yup from 'yup';
import { CHANGE_AVAILABILITY } from 'actions/chargerOcpp';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import Select from 'components/inputs/Select';
import { useTranslation } from 'react-i18next';
import { GET_STATION_CHARGER_OPERATIONS, MANAGE_STATION_CHARGER_OPERATIONS } from 'components/common/constant';

const ChangeAvailabilityForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const chargerDetailData = useSelector((state) => state.charger.chargerDetails);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const getChangeAvailability = useCallback((data, resetForm) => {
    dispatch({
      type: CHANGE_AVAILABILITY.REQUEST,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Availability change successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  const getStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  const ChangeAvailabilitySchema = Yup.object().shape({
    connectorId: Yup.number().required(t('changeAvailabilityForm.connectorId')),
    type: Yup.string().required(t('changeAvailabilityForm.type')).max(100, t('changeAvailabilityForm.maxlimit')),
  });

  const manageStationChargerOperations =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_STATION_CHARGER_OPERATIONS),
      (data) => data.name
    );

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">{t('changeAvailabilityForm.formTitle')}</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={{ connectorId: '', type: '' }}
              validationSchema={ChangeAvailabilitySchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const formData = {
                  id: chargerId,
                  ...values,
                };
                getChangeAvailability(formData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, setFieldValue, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col xl={6} lg={12}>
                        <Select
                          isRequired
                          label={t('changeAvailabilityForm.connectorName')}
                          placeholder={t('changeAvailabilityForm.connectorPlaceholder')}
                          options={_.map(_.get(chargerDetailData, 'plugs', []), (item) => {
                            return { label: `${item.name} - ${item.connector_id}`, value: item.connector_id };
                          })}
                          name="connectorId"
                          value={values.connectorId}
                          onChange={(val) => setFieldValue(`connectorId`, val)}
                          error={errors.connectorId && touched.connectorId ? errors.connectorId : null}
                        />
                      </Col>
                      <Col xl={6} lg={12}>
                        <Select
                          isRequired
                          label={t('changeAvailabilityForm.typeLabel')}
                          placeholder={t('placeHolder.type')}
                          options={[
                            { label: 'Inoperative', value: 'Inoperative' },
                            { label: 'Operative', value: 'Operative' },
                          ]}
                          name="type"
                          value={values.type}
                          onChange={(val) => {
                            setFieldValue(`type`, val);
                          }}
                          error={errors.type && touched.type ? errors.type : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    {!_.isEmpty(manageStationChargerOperations) ||
                    (!_.isEmpty(getStationChargerOperations) && !_.isEmpty(manageStationChargerOperations)) ? (
                      <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                        {t('changeAvailabilityForm.changeAvailabilityButton')}
                      </Button>
                    ) : (
                      <Button className="serverOperation-save-btn save--btn"> {t('changeAvailabilityForm.changeAvailabilityButton')}</Button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default ChangeAvailabilityForm;
